import { httpClient } from '@/shared/api/http-client';
import {
  adminUserSchema,
  sessionResponseSchema,
  type AdminUser,
} from '@/features/auth/model/session';

export interface LoginCredentials {
  email: string;
  password: string;
}

export async function loginAdmin(
  credentials: LoginCredentials,
): Promise<AdminUser> {
  const response = await httpClient.post<unknown>(
    '/auth/admin/login',
    credentials,
  );
  return sessionResponseSchema.parse(response.data).user;
}

export async function getSession(): Promise<AdminUser> {
  const response = await httpClient.get<unknown>('/auth/profile');
  return adminUserSchema.parse(response.data);
}

export async function logoutAdmin(): Promise<void> {
  await httpClient.post('/auth/logout');
}
